import axios from 'axios'
import Constantes from '../../utils/constantes'
import Alert from '../../utils/alert'

const state = {
	anuncios: [],
	destaques: [],
	mensagens: [],
	empresa: null,
	qtdAnuncios: "",
	detalheEstoque: [],
	imgSelect: "",
	filtro: null,
	filtroCatalogo: []
}

// getters
const getters = {
	anuncios(state) {
		return state.anuncios
	},
	destaques(state) {
		return state.destaques
	},
	empresa(state) {
		return state.empresa
	},
	mensagens(state) {
		return state.mensagens
	},
	qtdAnuncios(state) {
		return state.qtdAnuncios
	},
	imgSelect(state) {
		return state.imgSelect
	},
	detalheEstoque(state) {
		return state.detalheEstoque
	},
	filtroCatalogo: state => state.filtroCatalogo
}

// actions
const actions = {
	carregarDestaques({ commit, dispatch, state }, payload) {		
		return new Promise((resolve, reject) => {
			commit('core/setLoading', true, { root: true })
			commit('core/clearError', null, { root: true })
			axios({
				method: 'GET',
				url: `${Constantes.URL_SERVIDOR}/anuncio/destaque?empIntCod=${payload.empIntCod}`
			}).then(
				result => {
					if (result.data !== '') {
						commit('setDestaques', result.data)
					} else {
						commit('core/setError', { message: 'Erro ao carregar Destaques.' }, { root: true })
					}
					commit('core/setLoading', false, { root: true })
					resolve()
				},
				error => {
					console.error(error)
					commit('core/setError', error, { root: true })
					commit('core/setLoading', false, { root: true })
					reject()
				}
			)
		})
	},
	carregarAnuncios({ commit, dispatch, state }, payload) {
		return new Promise((resolve, reject) => {	
			//Quando limpa o campo de pesquisa do cabeçalho, page e size estão vindo como undefined.		
			if (typeof payload.page === 'undefined') 
				payload.page = 0;

			if (typeof payload.size === 'undefined') 
				payload.size = 24;

			// Por algum motivo as vezes o primeiro paylod.page vem número não inteiro, por esse motivo está validando 
			// e arredondando para cima (0.00008 = 1)
			if (!Number.isInteger(payload.page)) 
				payload.page = Math.ceil(payload.page);
			let urlRequest = `${Constantes.URL_SERVIDOR}/anuncio/empresapaginada?empIntCod=${payload.empIntCod}&page=${payload.page}&size=${payload.size}`;
			if (state.filtroCatalogo.length > 0) {
				urlRequest = `${Constantes.URL_SERVIDOR}/anuncio/empresapaginada?empIntCod=${payload.empIntCod}&page=${payload.page}&size=${payload.size}&caiStrCod=${state.filtroCatalogo}`;
			}

			if (payload.page === 0) {
				commit('limparAnuncios')
			}
			commit('core/setLoading', true, { root: true })
			commit('core/clearError', null, { root: true })
			axios({
				method: 'GET',
				url: urlRequest
			}).then(
				result => {
					if (result.data !== '') {
						commit('setAnuncios', result.data)
						commit('setQtdAnuncios', result.data.length)
					} else {
						commit('core/setError', { message: 'Erro ao carregar Anuncios.' }, { root: true })
					}
					commit('core/setLoading', false, { root: true })
					resolve()
				},
				error => {
					console.error(error)
					commit('core/setError', error, { root: true })
					commit('core/setLoading', false, { root: true })
					reject()
				}
			)
		})
	},
	filtrarAnuncios({ commit, state }) {
		if (!state.filtro) {
			return; // Se o filtro não estiver definido, saia da ação
		}
		const { codigo, nome } = state.filtro;
		// Aplicar o filtro aos anúncios
		const anunciosFiltrados = state.anuncios.filter((anuncio) => {
			return (
				(!codigo || anuncio.fitStrCoditefabricante.includes(codigo)) &&
				(!nome || anuncio.fitStrNme.toLowerCase().includes(nome.toLowerCase()))
			);
		});
		// Atualizar a lista de anúncios com os anúncios filtrados
		commit('limparAnuncios')
		commit('setAnuncios', anunciosFiltrados);
		commit('setQtdAnuncios', anunciosFiltrados.length)

	},
	filtrarCatalogos({ commit, state }, payload) {
		return new Promise((resolve, reject) => {	
			if (!state.filtroCatalogo) {
				return; // Se o filtro não estiver definido, saia da ação
			}			

			commit('limparAnuncios', state)			
			commit('setFiltroCatalogo', payload.codFabricante)			
			commit('core/setLoading', true, { root: true })
			commit('core/clearError', null, { root: true })
			axios({
				method: 'GET',
				url: `${Constantes.URL_SERVIDOR}/anuncio/empresapaginada?empIntCod=${payload.codEmpresa}&page=0&size=24&caiStrCod=${state.filtroCatalogo}`
			}).then(
				result => {
					if (result.data !== '') {
						commit('setAnuncios', result.data)						
						commit('setQtdAnuncios', result.data.length)
					} else {
						commit('core/setError', { message: 'Erro ao carregar Anuncios.' }, { root: true })
					}
					commit('core/setLoading', false, { root: true })
					resolve()
				},
				error => {
					console.error(error)
					commit('core/setError', error, { root: true })
					commit('core/setLoading', false, { root: true })
					reject()
				}
			)
		})



	},
	procurarAnuncio({ commit }, payload) {
		commit('core/setLoading', true, { root: true })
		commit('core/clearError', null, { root: true })
		axios({
			method: 'GET',
			url: `${Constantes.URL_SERVIDOR}/anuncio/peca?empIntCod=${payload.empIntCod}&peca=${payload.texto}`
		}).then(
			result => {
				if (result.data !== '') {					
					commit('addAnunciosLink', result.data)
				} else {
					commit('core/setError', { message: 'Erro ao carregar Anuncios.' }, { root: true })
				}
				commit('core/setLoading', false, { root: true })
			},
			error => {
				console.error(error)
				commit('core/setError', error, { root: true })
				commit('core/setLoading', false, { root: true })
			}
		)
	},
	carregarEstoque({ commit }, payload) {
		commit('core/setLoading', true, { root: true })
		commit('core/clearError', null, { root: true })
		axios({
			method: 'GET',
			url: `${Constantes.URL_SERVIDOR}/carga/peca?empIntCod=${payload.empresa.empIntCod}&codIteFabricante=${payload.fitStrCoditefabricante}`
		}).then(
			result => {
				if (result.data !== '') {
					commit('setDetalheEstoque', result.data)
				} else {
					commit('core/setError', { message: 'Erro ao carregar Detalhes do Estoque.' }, { root: true })
				}
				commit('core/setLoading', false, { root: true })
			},
			error => {
				console.error(error)
				commit('core/setError', error, { root: true })
				commit('core/setLoading', false, { root: true })
			}
		)
	},
	carregarEmpresa({ commit, dispatch }, payload) {
		commit('core/clearError', null, { root: true })
		if (payload) {
			axios({
				method: 'GET',
				url: `${Constantes.URL_SERVIDOR}/empresa/id?empIntCod=${payload}`
			}).then(
				result => {
					if (result.data !== '') {
						commit('setEmpresa', result.data)
						//dispatch('pedido/removeItensCarrinhoOutraLoja', { empIntCod: payload }, { root: true })
						//dispatch('cliente/removeUserOutraLoja', { empIntCod: payload }, { root: true })
					} else {
						commit('core/setError', { message: 'Erro ao carregar Empresa.' }, { root: true })
					}
				},
				error => {
					console.error(error)
					commit('core/setError', error, { root: true })
				}
			)
		}
	},
	postarMensagem({ commit, dispatch }, payload) {
		commit('core/setLoading', true, { root: true })
		commit('core/clearError', null, { root: true })
		axios({
			method: 'POST',
			url: Constantes.URL_SERVIDOR + '/mensagem/save',
			data: payload
		}).then(
			result => {
				if (result.data !== '') {
					dispatch('carregarMensagens', payload.anuncio);
				} else {
					commit('core/setError', { message: 'Erro ao postar mensagem.' }, { root: true })
				}
				commit('core/setLoading', false, { root: true })
			},
			error => {
				console.error(error)
				commit('core/setLoading', false, { root: true })
				commit('core/setError', error, { root: true })
			}
		)
	},
	cadastrarAviso({ commit, dispatch }, payload) {
		commit('core/setLoading', true, { root: true })
		commit('core/clearError', null, { root: true })
		axios({
			method: 'POST',
			url: Constantes.URL_SERVIDOR + '/anuncioaviso/save',
			data: payload
		}).then(
			result => {
				if (result.data !== '') {
					Alert.info("", "Aviso cadastrado!")
				} else {
					commit('core/setError', { message: 'Aviso já cadastrado previamente.' }, { root: true })
				}
				commit('core/setLoading', false, { root: true })
			},
			error => {
				console.error(error)
				commit('core/setLoading', false, { root: true })
				commit('core/setError', error, { root: true })
			}
		)
	},
	carregarMensagens({ commit }, payload) {
		commit('setMensagens', [])
		commit('core/clearError', null, { root: true })
		commit('core/setLoading', true, { root: true })
		axios({
			method: 'GET',
			url: `${Constantes.URL_SERVIDOR}/mensagem/mensagens?ancIntCod=${payload.ancIntCod}`
		}).then(
			result => {
				if (result.data !== '') {
					commit('setMensagens', result.data)
				} else {
					commit('core/setError', { message: 'Erro ao carregar Mensagens.' }, { root: true })
				}
				commit('core/setLoading', false, { root: true })
			},
			error => {
				console.error(error)
				commit('core/setError', error, { root: true })
				commit('core/setLoading', false, { root: true })
			}
		)
	},
	pesquisar({ commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			commit('core/setLoading', true, { root: true })
			commit('core/clearError', null, { root: true })
			axios({
				method: 'POST',
				url: Constantes.URL_SERVIDOR_IS + '/b2canuncio/buscar',
				headers: {
					'semtoken': 'true',
				},
				data: payload
			}).then(
				result => {
					if (result.data !== '') {
						if (result.data.length === 0) {
							Alert.warn("", "A pesquisa não encontrou nenhum resultado!")
						} else {
							commit('addAnuncios', result.data)
						}
					} else {
						commit('core/setError', { message: 'Erro ao pesquisar item.' }, { root: true })
					}
					commit('core/setLoading', false, { root: true })
					resolve()
				},
				error => {
					console.error(error)
					commit('limparAnuncios')
					commit('core/setLoading', false, { root: true })
					commit('core/setError', { message: 'Erro ao pesquisar item. Verifique se o nome do item pesquisado está correto.' }, { root: true })
					reject()
				}
			)
		})
	},
	carregarImgSelect({ commit }, payload) {
		commit('setImgSelect', payload)
	}
}

// mutations
const mutations = {
	setAnuncios(state, payload) {
		state.anuncios = state.anuncios.concat(payload)
	},
	addAnuncios(state, payload) {
		state.anuncios = [...state.anuncios, ...payload]
	},
	addAnunciosLink(state, payload) {
		// state.anuncios = [];
		state.anuncios = payload
	},
	limparAnuncios(state) {
		state.anuncios = []
	},
	setEmpresa(state, payload) {
		state.empresa = payload
	},
	setMensagens(state, payload) {
		state.mensagens = payload
	},
	setQtdAnuncios(state, payload) {
		state.qtdAnuncios = payload
	},
	setDestaques(state, payload) {
		state.destaques = payload
	},
	setImgSelect(state, payload) {
		state.imgSelect = payload
	},
	setDetalheEstoque(state, payload) {
		state.detalheEstoque = payload
	},
	setFiltro(state, filtro) {
		state.filtro = filtro;
	},
	setFiltroCatalogo(state, filtro) {
		if(filtro === null){
			state.filtroCatalogo = [];
		}
		else{
			if (filtro.length > 0) {
				state.filtroCatalogo = [...state.filtroCatalogo, ...filtro];
				state.filtroCatalogo = [...new Set(state.filtroCatalogo)];
			} else
				state.filtroCatalogo = filtro;
		}		
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
